module.exports = __webpack_public_path__ + "img/icons BFr_4.90538df8.svg";